import { Box, Button, Card, CircularProgress, Dialog, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { AddProductCommand, Organization, Product, UserItem } from "../../../../api/models/schema";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addProductApi, deleteProductApi, editProductApi, getOrganizationApi } from "../../../../api/liveMarketingApi";
import { useApi } from "../../../../hooks/useApi";
import { getCookie } from "cookies-next";
import { BasicButton } from "../../../../common/basicButton";
import { ProductGrid } from "./productGrid";
import { AddProductForm } from "./addProductForm";
import { set } from "react-hook-form";


export function ProductPage() {

    const [userData, setUserData] = useState<UserItem | undefined>(undefined);
    const [organization, setOrganization] = useState<Organization | undefined>(undefined);
  
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [showAddForm, setShowAddForm] = useState<boolean>(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

    const [selectedProduct, setSelectedProduct] = useState<Product | undefined>(undefined);

    const params = useParams();
    const navigate = useNavigate();

    const getOrganizationRequest = useApi(getOrganizationApi);
    const addProductRequest = useApi(addProductApi);
    const editProductRequest = useApi(editProductApi);
    const deleteProductRequest = useApi(deleteProductApi);


    useEffect(() => {
        const user = getCookie("userData") as string;
        if (user) {
          setUserData(JSON.parse(user));
        } else {
          navigate(`/login`);
        }
      }, []);
    
      useEffect(() => {
        if (userData) {
          refreshPage();
        }
      }, [userData]);

      useEffect(() => {
        if (addProductRequest.data) {
            refreshPage();
        }
      }, [addProductRequest.data]);

      useEffect(() => {
        if (addProductRequest.error) {
            setErrorMessage(addProductRequest.error?.message ?? '');
        }
      }, [addProductRequest.error]);

      useEffect(() => {
        if (editProductRequest.data) {
            refreshPage();
        }
      }, [editProductRequest.data]);

      useEffect(() => {
        if (editProductRequest.error) {
            setErrorMessage(editProductRequest.error?.message ?? '');
        }
      }, [editProductRequest.error]);

      useEffect(() => {
        if (deleteProductRequest.data) {
            refreshPage();
        }
      }, [deleteProductRequest.data]);

      useEffect(() => {
        if (deleteProductRequest.error) {
            setErrorMessage(deleteProductRequest.error?.message ?? '');
        }
      }, [deleteProductRequest.error]);

        // Organization Effects
  useEffect(() => {

    if (getOrganizationRequest.data) {
      setOrganization(getOrganizationRequest.data);
    }

  }, [getOrganizationRequest.data]);

      function refreshPage(){
        getOrganizationRequest.request(params.orgId, userData?.appUserName);
        setSelectedProduct(undefined);
        setShowAddForm(false);
        setShowDeleteDialog(false);
        setErrorMessage('');
     }

     function openForm(){
        setShowAddForm(true);
     }

     function closeForm(){
        setSelectedProduct(undefined);
        setShowAddForm(false);
     }

     function addProductHandler(productCommand: AddProductCommand){
        setErrorMessage('');
        if(productCommand.productId){
            editProductRequest.request(organization?.orgId, productCommand.productId, productCommand, userData?.appUserName);
        }
        else{
            addProductRequest.request(organization?.orgId, productCommand, userData?.appUserName);
        }
        
      }

      function deleteProduct(productId: number){
          deleteProductRequest.request(organization?.orgId, productId, userData?.appUserName);
      }

      function selectProductHandler(productId: number){
        const matchProduct = organization?.products.find(product => product.productId === productId);
        setSelectedProduct(matchProduct);
        openForm();
        
      }

      function deleteProductHandler(productId: number){
        const matchProduct = organization?.products.find(product => product.productId === productId);
        setSelectedProduct(matchProduct);
        setShowDeleteDialog(true);
      }



    function displayPageData() {
        return (
            <Card
            style={{
              maxWidth: 1400,
              margin: 5,
              padding: 20,
              border: "1px solid #cecece",
              borderRadius: 10,
              backgroundColor: "#f2f2f2",
              textDecoration: "none",
            }}
          >
            {/* <h2>Jobs</h2> */}
            <Grid container>
              {userData?.isSuperAdmin && (
                <Grid item xs={12}>
                  <BasicButton
                    onClick={openForm}
                    labelText="Add Product"
                  />
                </Grid>
              )}
    
              <Grid item xs={12}>
                <br />
                {organization?.products && (
                  <ProductGrid
                    products={organization?.products}
                    selectProduct={selectProductHandler}
                    deleteProduct={deleteProductHandler}
                  />
                )}
              </Grid>

                    <AddProductForm
                        product= {selectedProduct}
                        isLoading={addProductRequest.loading}
                        open={showAddForm} 
                        onClose={closeForm}
                        errorMessage={errorMessage}
                        onUpdate={addProductHandler}
                    />
            </Grid>

            <Dialog open={showDeleteDialog}>
            <DialogTitle>Delete Product</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete '<strong>{selectedProduct?.name}</strong>' ?
              </DialogContentText>

              <Button
              onClick={() => {deleteProduct(selectedProduct?.productId ?? 0);}}
              autoFocus
            >
                Delete
            </Button>
              <Button onClick={() => {setShowDeleteDialog(false);}}>Cancel</Button>
            </DialogContent>
            </Dialog>


          </Card>
        );
        }

    return (
        <>
        <br/>
          <Link to={`/dashboard/${params.orgId}`}>Go back to Dashboard</Link>
          <h1>{organization?.name} Products</h1>
          {getOrganizationRequest.loading && <CircularProgress />}
          {!getOrganizationRequest.loading && displayPageData()}
        </>
      );

}